import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Car } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';

const NotFound = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-8">
          <div className="w-24 h-24 bg-[#1a5c3b]/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Car className="w-12 h-12 text-[#1a5c3b]" />
          </div>
          <h1 className="text-6xl font-bold text-[#1a5c3b] mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            {language === 'en' ? 'Page Not Found' : 'Page non trouvée'}
          </h2>
          <p className="text-gray-600">
            {language === 'en' 
              ? 'The page you are looking for does not exist or has been moved.'
              : 'La page que vous recherchez n\'existe pas ou a été déplacée.'}
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-[#1a5c3b] hover:bg-[#165432] text-white px-6 py-3">
              <Home className="w-4 h-4 mr-2" />
              {language === 'en' ? 'Go Home' : 'Accueil'}
            </Button>
          </Link>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="border-[#1a5c3b] text-[#1a5c3b] px-6 py-3"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {language === 'en' ? 'Go Back' : 'Retour'}
          </Button>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">
            {language === 'en' ? 'Looking for auto financing?' : 'Vous cherchez un financement auto?'}
          </p>
          <Link to="/demander-un-pret-auto">
            <Button variant="link" className="text-[#1a5c3b]">
              {language === 'en' ? 'Apply for a loan →' : 'Demander un prêt →'}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
